/**
 * Global plans/upgrade UX (Stage C).
 *
 * Anywhere in the app can:
 *   openPlansModal({ highlight: 'videoAds' }) — open the premium plans
 *     comparison modal (mounted once in AppLayout), optionally
 *     highlighting the feature that triggered it.
 *   showUpgradeToast(message, feature) — top-of-page popup with the
 *     friendly limit/lock message and a "See plans" button.
 *
 * Backends signal these with HTTP 403 + { upgrade: true, code:
 * 'quota_exceeded' | 'feature_not_in_plan' | 'changes_budget_exhausted' }.
 */
export const PLANS_MODAL_EVENT = 'autonoma:open-plans';
export const UPGRADE_TOAST_EVENT = 'autonoma:upgrade-required';

export function openPlansModal(detail = {}) {
  try {
    window.dispatchEvent(new CustomEvent(PLANS_MODAL_EVENT, { detail }));
  } catch { /* SSR/test safety */ }
}

/**
 * `code` distinguishes a QUOTA CAP ('quota_exceeded' /
 * 'changes_budget_exhausted' — the merchant used everything their plan
 * gives this month) from a GATED feature ('feature_not_in_plan'). A cap
 * is the PlanLimitOverlay's moment — opened centrally by lib/api.js on
 * the server's 403 (or by the lib/quota.js pre-check before the request
 * is even sent), so this toast ignores cap codes; a gate keeps the "See
 * plans" toast — referral credits are only ever granted for features the
 * plan already has, so referring can't unlock a gate.
 */
export function showUpgradeToast(message, feature, code = null) {
  try {
    window.dispatchEvent(new CustomEvent(UPGRADE_TOAST_EVENT, { detail: { message, feature, code } }));
  } catch { /* SSR/test safety */ }
}

export const QUOTA_CAP_CODES = ['quota_exceeded', 'changes_budget_exhausted'];

/** Did the merchant hit a monthly quota cap (as opposed to a plan gate)? */
export function isQuotaCapCode(code) {
  return QUOTA_CAP_CODES.includes(code);
}

/** Is this response a plan-limit / gated-feature error? */
export function isUpgradeError(res, data) {
  return (res?.status === 403 && data?.upgrade === true)
    || ['quota_exceeded', 'feature_not_in_plan', 'changes_budget_exhausted'].includes(data?.code);
}
